/* eslint-disable import/no-unresolved */
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  Stack,
  Button,
} from '@mui/material';

const boxStyle = {
  position: 'absolute',
  height: 'fit-content',
  width: '300px',
  backgroundColor: '#fff',
  borderRadius: '15px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 4,
};

interface DeleteInvoiceProps {
  show: boolean;
  handleAction: () => void;
  handleModalClose: (type: 'delete' | 'refund' | 'info') => void;
}
const DeleteInvoice: React.FC<DeleteInvoiceProps> = ({
  show,
  handleAction,
  handleModalClose,
}) => (
  <div>
    <Modal
      open={show}
      onClose={() => handleModalClose('delete')}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Slide direction="up" in={show} mountOnEnter unmountOnExit>
        <Box sx={boxStyle}>
          <Typography
            sx={{ fontSize: '20px', fontWeight: 700, color: '#051252' }}
          >
            Delete Invoice ?
          </Typography>

          <Stack mt={4} width="210px" mx="auto" spacing={2}>
            <Button variant="contained" onClick={handleAction}>
              Yes
            </Button>
            <Button
              onClick={() => handleModalClose('delete')}
              variant="contained"
              sx={{
                backgroundColor: (theme) => theme.general.cancel,
                '&:hover': {
                  backgroundColor: '#922c18',
                },
              }}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </Slide>
    </Modal>
  </div>
);

export default DeleteInvoice;
